var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightthemeicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 44,
    viewBox: "0 0 45 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 22C0 9.84974 9.84974 0 22 0H23C35.1503 0 45 9.84974 45 22C45 34.1503 35.1503 44 23 44H22C9.84973 44 0 34.1503 0 22Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_153_20)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4545 22H8M38 22H32.5455M16.25 15.25L12.3936 11.3936M33.6064 32.6064L29.75 28.75M16.25 28.75L12.3936 32.6064M33.6064 11.3936L29.75 15.25",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 27.4545C24.4466 27.4545 25.834 26.8799 26.8569 25.8569C27.8798 24.834 28.4545 23.4466 28.4545 22C28.4545 20.5534 27.8798 19.166 26.8569 18.143C25.834 17.1201 24.4466 16.5454 23 16.5454C21.5533 16.5454 20.1659 17.1201 19.143 18.143C18.1201 19.166 17.5454 20.5534 17.5454 22C17.5454 23.4466 18.1201 24.834 19.143 25.8569C20.1659 26.8799 21.5533 27.4545 23 27.4545Z",
    fill: "black",
    fillOpacity: 0.16,
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 31.5455V37M23 7V12.4545",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_153_20"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(8 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightthemeicon);
export default __webpack_public_path__ + "static/media/lightthemeicon.202f1d34422f342f05c66806f7de75bd.svg";
export { ForwardRef as ReactComponent };